import { Action } from '@/_core/fluxstore/types';
import { ProductsState } from '../types';
import { useProductsStore } from '../useModule';
import { useSendCommand } from '@/_core/cqrs/use';
import { ChangeProductName as ChangeProductNameCommand } from '@/api/manageProducts/commands';

const { registerMiddleware, registerReducer } = useProductsStore();

export class ChangeProductName extends Action<ProductsState> {
    public static ACTION_TYPE = 'ChangeProductName';

    public constructor(public id: string, public name: string) {
        super(ChangeProductName.ACTION_TYPE);
    }
}

const middleware = async (state: ProductsState, action: ChangeProductName): Promise<boolean> => {
    return useSendCommand(action, {
        createCommand: () => new ChangeProductNameCommand(action.id, action.name),
    });
};

const initAppDataMiddleware = async (state: ProductsState, action: ChangeProductName): Promise<boolean> => {
    if (initAppData.isInWsContext) {
        const product = initAppData.currentWs.products.find((x) => x.id === action.id);
        product.name = action.name;
    }

    return true;
};

const reducer = (state: ProductsState, action: ChangeProductName): void => {
    const product = state.products.find((x) => x.id == action.id);
    product.name = action.name;
};

//@ts-ignore
registerMiddleware(ChangeProductName.ACTION_TYPE, middleware);

//@ts-ignore
registerMiddleware(ChangeProductName.ACTION_TYPE, initAppDataMiddleware);

//@ts-ignore
registerReducer(ChangeProductName.ACTION_TYPE, reducer);
